module.exports = __webpack_public_path__ + "static/img/point_icon_11.49581486.svg";